<template>
  <div class="columns is-multiline">
    <div class="container">
      <div class="column is-12">
        <h3 class="title is-5">Políticas y términos de garantía</h3>
      </div>
      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <div class="column is-6">
          <p>Consulta aquí los <a
              href="https://stilotex-website.s3.amazonaws.com/docs/politicas-garantias-stilotex.pdf" target="_blank">políticas</a> y <a href="https://stilotex-website.s3.amazonaws.com/docs/terminos-garantia.xlsx">términos</a> de garantías.</p>

          <div class="field">
            <input name="optInWarranty" id="optInWarranty" v-model="warrantyForm.optInWarranty" type="checkbox">
            <label for="optInWarranty">Acepto términos y condiciones de garantías</label>
          </div>
          <div class="field">
            <label for="description">Descripción garantía (describe la situación que presenta tú producto):</label>
            <textarea name="description" id="description" class="input" v-model="warrantyForm.description" rows="5" cols="50"></textarea>
          </div>
        </div>
        <div class="column is-6">
          <p>Adjunte registro fotográfico, factura de venta y certificado de venta(si aplica, en un solo archivo)</p>
          <div class="dropbox">
            <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                   accept="image/*" class="input-file">
            <p v-if="isInitial">
             Arrastre los archivos<br> o dar click para adjuntar
            </p>
            <p v-if="isSaving">
              Subiendo {{ fileCount }} archivo(s)...
            </p>
          </div>
        </div>
      </form>
      <div v-if="isSuccess">
        <h2>Se han adjuntado {{ uploadedFiles.length }} archivo(s) con éxito.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">Adjuntar de nuevo</a>
        </p>
        <ul class="list-unstyled">
          <li v-for="item in uploadedFiles">
            <img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">
          </li>
        </ul>
        <div class="column is-6">
          <div class="field">
            <button class="button is-black" :disabled="!warrantyForm.optInWarranty || !warrantyForm.description" @click="onSubmit">Enviar</button>
          </div>
        </div>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <h2>Uploaded failed.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">Intenta de nuevo</a>
        </p>
        <pre>{{ uploadError }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { upload } from  '../../../services/file-upload.fake.service'; // fake service
// import { upload } from '../../../services/file-upload.service';   // real service

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
  name: 'app',
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos',
      warrantyForm:{
        description: '',
        attached: 'link',
        optInWarranty: false,
        code: '',
      }
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    onSubmit() {
      const date = new Date();
      this.warrantyForm.code = `${date.getFullYear().toString()}${date.getMonth()+1}${date.getDate()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}`;
      this.$emit('done', {
        key: 'warrantyForm',
        location: this.warrantyForm
      });
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING

      upload(formData)
          .then(x => {
            this.uploadedFiles = [].concat(x)
            this.currentStatus = STATUS_SUCCESS
            this.warrantyForm.attached = this.uploadedFiles
          })
          .catch(err => {
            this.uploadError = err.response
            this.currentStatus = STATUS_FAILED
          });
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array
          .from(Array(fileList.length).keys())
          .map(x => {
            formData.append(fieldName, fileList[x], fileList[x].name)
          });

      // save it
      this.save(formData)
    }
  },
  mounted() {
    this.reset()
  },
}
</script>
<style lang="scss">
.field, .column {
  a {
    color: #ffffff;
    font-weight: bold;
  }
  textarea {
    min-height: 140px;
  }
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
